module.exports = __webpack_public_path__ + "media/images/emblems/Rueeggisberg-coat_of_arms-77023db9dbac1a53bff6e090af805abe.svg";